import { SizeAll } from '../../themes/default/size/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var themeSize = function themeSize() {
  var sizeOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedSize = _objectSpread({}, SizeAll);

  var keys = Object.keys(sizeOverrides);
  keys.forEach(function (sizeName) {
    if (typeof sizeOverrides[sizeName] === 'number') {
      themedSize[sizeName] = sizeOverrides[sizeName];
    } else {
      console.error("Size override must be a number - ignoring ".concat(sizeName, " override"));
    }
  });
  return themedSize;
};

export { themeSize };
